var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base_text_input"},[(_vm.label)?_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',{attrs:{"id":_vm.id,"name":_vm.id},domProps:{"value":_vm.value},on:_vm._d({},[_vm.EVENTS.INPUT,_vm.handleChange])})])
}
var staticRenderFns = []

export { render, staticRenderFns }